import { getExpression } from 'utilities';
import { GetTotalPublishedValuationsExpressionParams } from './getTotalPublishedValuationsExpression.types';

const getTotalPublishedValuationsExpression = (params: GetTotalPublishedValuationsExpressionParams): string => {
  const { allPublishedValuationsExpression, alphabet, columnIndex } = params;

  if (columnIndex === undefined || columnIndex === null || columnIndex < 0) {
    return '';
  }

  const columnLegend = alphabet[columnIndex];
  if (!columnLegend) {
    return '';
  }

  // Total Published Valuations Expression
  const totalPublishedDirectInvestedCapitalExpression = getExpression({
    columnLegend,
    expr: `SUM(${allPublishedValuationsExpression})`,
  });

  return totalPublishedDirectInvestedCapitalExpression;
};

export default getTotalPublishedValuationsExpression;
